// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js!../../../theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Textarea {
  font-weight: 500;
  border: 1px solid transparent;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  line-height: 1.5rem;
  border-radius: 0.375rem;
  width: calc(100% - 2rem - 2px) !important;
  resize: vertical;
  transition: all 150ms ease-in-out;
  cursor: pointer;
}
.Textarea.primary {
  background-color: rgb(217, 217, 217);
  color: #1a1a1a;
}
.Textarea.primary:hover {
  background-color: rgb(217, 217, 217);
  outline: none;
  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);
  border-color: rgb(114, 113, 113);
}
.Textarea.primary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);
  border-color: rgb(114, 113, 113);
}
.Textarea.primary:active {
  background-color: #8d8d8d;
  border-color: rgb(114, 113, 113);
}
.Textarea.secondary {
  background-color: rgb(38, 38, 38);
  color: rgb(229, 229, 229);
}
.Textarea.secondary:hover {
  background-color: #191919;
  outline: none;
  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);
  border-color: rgb(114, 113, 113);
}
.Textarea.secondary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);
  border-color: rgb(114, 113, 113);
}
.Textarea.secondary:active {
  background-color: #191919;
  border-color: rgb(114, 113, 113);
}
.Textarea[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/client/HoosatUI/src/Elements/Form/Textarea/Textarea.css"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,aAAa;EACb,8CAA8C;EAC9C,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8CAA8C;EAC9C,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,8CAA8C;EAC9C,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8CAA8C;EAC9C,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["@import '../../../theme.css';\n\n.Textarea {\n  font-weight: 500;\n  border: 1px solid transparent;\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  border-radius: 0.375rem;\n  width: calc(100% - 2rem - 2px) !important;\n  resize: vertical;\n  transition: all 150ms ease-in-out;\n  cursor: pointer;\n}\n.Textarea.primary {\n  background-color: rgb(217, 217, 217);\n  color: #1a1a1a;\n}\n.Textarea.primary:hover {\n  background-color: rgb(217, 217, 217);\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);\n  border-color: rgb(114, 113, 113);\n}\n.Textarea.primary:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);\n  border-color: rgb(114, 113, 113);\n}\n.Textarea.primary:active {\n  background-color: #8d8d8d;\n  border-color: rgb(114, 113, 113);\n}\n.Textarea.secondary {\n  background-color: rgb(38, 38, 38);\n  color: rgb(229, 229, 229);\n}\n.Textarea.secondary:hover {\n  background-color: #191919;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);\n  border-color: rgb(114, 113, 113);\n}\n.Textarea.secondary:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(141, 141, 141, 0.5);\n  border-color: rgb(114, 113, 113);\n}\n.Textarea.secondary:active {\n  background-color: #191919;\n  border-color: rgb(114, 113, 113);\n}\n.Textarea[disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
